export default "/_next/static/chunks/fonts/IBM Plex Sans Light-f7b732d3c31163f63bd288b0117e7cab.ttf";